import React from "react";

export function Report() {
    return (
        <>
        <center>
        <div class="right2">
        <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <h1>Annual Finance Report</h1><hr/>
            <a href="http://www.monroefd1nj.com/Budgets/MTFD1_APPROVED_BUDGET_2018.pdf"><button>2018 Finance Report</button></a>
            </div>
        </center>
        </>
    )
}